export enum TiposArchivosEnum {
    Texto = 1,
    Archivo = 2,
    Imagen = 3,
    Audio = 4,
    Video = 5,
    Ubicacion = 6,
    Url = 7   
}
